// import { SeatgeekConnectionConfiguration } from 'ngx-seatgeek-connection';
import { environment } from '../../environments/environment';
import { DigitalvenueConfiguration } from './digitalvenue-configuration.model';
import { InjectionToken } from '@angular/core';
import { DVMConfiguration } from './dvmconfiguration.model';

/*
*
* Application Configuration
*
*/
export const APP_CONFIG = new InjectionToken<DigitalvenueConfiguration>('Digitalvenue Configuration');
export const ApplicationConfiguration: DigitalvenueConfiguration = {
  // Select the type of application to load: Relocation or Season Tickets
  applicationType: 'Relocation',
  // Include the areas to be treated as GA, and the areas to be locked in the map
  generalAdmissionAreas: [],
  lockedAreas: [],
  // Default Price Type to be used when selecting a seat
  defaultPricetype: '',
  // Include areas search bar
  includeSearch: true,
  // Show Redirect pop-up when user has no series available
  redirect: {
    isRedirectEnabled: true,
    redirectURL: 'https://3ddigitalvenue.com/3dmap/clients/staples-center/',
  },
  // Add-ons configuration (only with applicationType: Relocation)
  addonsConfiguration: {
    isAddonsAvailable: true,
    addonsMaxSelection: 2
  },
  // Parking IDs and configuration
  parkingConfiguration: {
    isParkingAvailable: false,
    parkingSeriesID: null,
    parkingPricetype: null,
    // Garages transation - ID: Name
    parkingTranslation: {
    },
    // Maximum slots per user
    parkingMaxSelection: null
  },
  // Data to be shown in the popovers (it has to be previously imported)
  popoversConfiguration: {
    includeDescription: true,
    includeSeatsCount: true,
    includePricing: true
  },
  // Maximum seats per user
  seatsMaxSelection: 60,
  // Data Providers available: SeatGeek, MMC
  dataProvider: 'MMC',
  // Use Pending Buffer for isolated seats error
  preventIsolatedSeats: false,
  // Load areamap or blockmap
  mapType: 'blockmap',
  // Interface colors
  colors: {
    mapElement: {
      available: '#1F8EFA',
      selected: '#eaeaea',
      pending: 'orange'
    },
    buttons: '#002D74',
    buttonsHover: '#007bff',
    popoverText: '#98A7B9',
    topbar: '#002D74',
    bottomInterface: '#141414',
    subInterface: {
      header: '#141414',
      listTitle: '#b8b6b7'
    },
    tickets: {
      text: '#252525',
      actions: '#252525',
      actionsHover: '#398be2'
    }
  },
  allowBuyExtras: false
};

export const DVM_CONFIG = new InjectionToken<DVMConfiguration>('DVM Configuration');
export const DVMConfig: DVMConfiguration = {
    venue_id: 'nam-us-00036-lakers-premium',
    map_id: 'blockmap',
    container: 'viewer-container',
};

/*
*
* TK3D Configuration
*
*/
// export const Tk3dConfiguration: Tk3dConfig = {
//   venue: 'nam-us-00096-chicagocubs',
//   // venue:  'nam-us-00077-mnufc',
//   flags: {
//     seatmap: {
//       available_by_default: false,
//       user_selection: false,
//       max_selection: 60,
//       multiple_selection: true
//     },
//     blockmap: {
//       available_by_default: false,
//       user_selection: false,
//       max_selection: 1,
//       multiple_selection: false
//     }
//   },
//   defaultPlugins: ['ThumbnailPlugin', 'RowsPlugin', 'NeighborsPlugin', 'ZoomButtonsPlugin'],
//   removeUnavailable: { seatmap: true, blockmap: true },
//   injectTk3dService: true,
//   neighborsInfo: {
//     "S_AA13": { "l": "S_AA14", "r": "S_12" }, "S_AA14": { "l": "S_AA15", "r": "S_AA13" }, "S_AA15": { "l": "S_AA16", "r": "S_AA14" }, "S_AA16": { "l": "S_AA18", "r": "S_AA15" }, "S_AA18": { "l": "S_AA19", "r": "S_AA16" }, "S_AA19": { "l": "S_AA20", "r": "S_AA18" }, "S_AA20": { "l": "S_AA21", "r": "S_AA18" }, "S_AA21": { "l": "S_AA22", "r": "S_AA19" }, "S_AA22": { "l": "S_23", "r": "S_AA21" }, "S_Bleacher": { "l": "S_134", "r": "S_134" }, "S_CreeLightingClub1": { "l": "S_CreeLightingClub2", "r": "S_305L" }, "S_CreeLightingClub2": { "l": "S_CreeLightingClub3", "r": "S_CreeLightingClub1" }, "S_CreeLightingClub3": { "l": "S_CreeLightingClub4", "r": "S_CreeLightingClub2" }, "S_CreeLightingClub4": { "l": "S_CreeLightingClub5", "r": "S_CreeLightingClub3" }, "S_CreeLightingClub5": { "l": "S_308L", "r": "S_CreeLightingClub4" }, "S_3": { "l": "S_4", "r": "S_102" }, "S_4": { "l": "S_5", "r": "S_3" }, "S_5": { "l": "S_6", "r": "S_4" }, "S_6": { "l": "S_8", "r": "S_5" }, "S_7": { "l": "S_8", "r": "S_6" }, "S_8": { "l": "S_9", "r": "S_6" }, "S_9": { "l": "S_10", "r": "S_8" }, "S_10": { "l": "S_11", "r": "S_9" }, "S_11": { "l": "S_12", "r": "S_10" }, "S_12": { "l": "S_13", "r": "S_11" }, "S_13": { "l": "S_14", "r": "S_12" }, "S_14": { "l": "S_15", "r": "S_13" }, "S_15": { "l": "S_16", "r": "S_14" }, "S_16": { "l": "S_18", "r": "S_14" }, "S_18": { "l": "S_19", "r": "S_16" }, "S_19": { "l": "S_20", "r": "S_18" }, "S_20": { "l": "S_21", "r": "S_19" }, "S_21": { "l": "S_22", "r": "S_20" }, "S_22": { "l": "S_23", "r": "S_21" }, "S_23": { "l": "S_24", "r": "S_22" }, "S_24": { "l": "S_25", "r": "S_23" }, "S_25": { "l": "S_26", "r": "S_24" }, "S_26": { "l": "S_27", "r": "S_25" }, "S_27": { "l": "S_28", "r": "S_25" }, "S_28": { "l": "S_29", "r": "S_27" }, "S_29": { "l": "S_30", "r": "S_28" }, "S_30": { "l": "S_31", "r": "S_29" }, "S_31": { "l": "S_32", "r": "S_30" }, "S_32": { "l": "S_133", "r": "S_31" }, "S_101": { "l": "S_102", "r": "S_202" }, "S_102": { "l": "S_103", "r": "S_101" }, "S_103": { "l": "S_104", "r": "S_102" }, "S_104": { "l": "S_105", "r": "S_103" }, "S_105": { "l": "S_106", "r": "S_104" }, "S_106": { "l": "S_107", "r": "S_105" }, "S_107": { "l": "S_108", "r": "S_106" }, "S_108": { "l": "S_109", "r": "S_107" }, "S_109": { "l": "S_110", "r": "S_108" }, "S_110": { "l": "S_111", "r": "S_109" }, "S_111": { "l": "S_112", "r": "S_110" }, "S_112": { "l": "S_113", "r": "S_111" }, "S_113": { "l": "S_114", "r": "S_112" }, "S_114": { "l": "S_115", "r": "S_113" }, "S_115": { "l": "S_116", "r": "S_114" }, "S_116": { "l": "S_117", "r": "S_115" }, "S_117": { "l": "S_118", "r": "S_116" }, "S_118": { "l": "S_119", "r": "S_117" }, "S_119": { "l": "S_120", "r": "S_118" }, "S_120": { "l": "S_121", "r": "S_119" }, "S_121": { "l": "S_122", "r": "S_120" }, "S_122": { "l": "S_123", "r": "S_121" }, "S_123": { "l": "S_124", "r": "S_122" }, "S_124": { "l": "S_125", "r": "S_123" }, "S_125": { "l": "S_126", "r": "S_124" }, "S_126": { "l": "S_127", "r": "S_125" }, "S_127": { "l": "S_128", "r": "S_126" }, "S_128": { "l": "S_129", "r": "S_127" }, "S_129": { "l": "S_130", "r": "S_128" }, "S_130": { "l": "S_131", "r": "S_129" }, "S_131": { "l": "S_132", "r": "S_130" }, "S_132": { "l": "S_133", "r": "S_131" }, "S_133": { "l": "S_134", "r": "S_132" }, "S_134": { "l": "S_233", "r": "S_133" }, "S_202": { "l": "S_203", "r": "S_101" }, "S_203": { "l": "S_204", "r": "S_202" }, "S_204": { "l": "S_205", "r": "S_203" }, "S_205": { "l": "S_206", "r": "S_204" }, "S_206": { "l": "S_207", "r": "S_205" }, "S_207": { "l": "S_208", "r": "S_206" }, "S_208": { "l": "S_209", "r": "S_207" }, "S_209": { "l": "S_210", "r": "S_208" }, "S_210": { "l": "S_212", "r": "S_209" }, "S_212": { "l": "S_213", "r": "S_210" }, "S_213": { "l": "S_214", "r": "S_212" }, "S_214": { "l": "S_215", "r": "S_213" }, "S_215": { "l": "S_216", "r": "S_214" }, "S_216": { "l": "S_217", "r": "S_215" }, "S_217": { "l": "S_218", "r": "S_216" }, "S_218": { "l": "S_220", "r": "S_217" }, "S_220": { "l": "S_221", "r": "S_218" }, "S_221": { "l": "S_222", "r": "S_220" }, "S_222": { "l": "S_223", "r": "S_221" }, "S_223": { "l": "S_225", "r": "S_222" }, "S_225": { "l": "S_226", "r": "S_223" }, "S_226": { "l": "S_227", "r": "S_225" }, "S_227": { "l": "S_228", "r": "S_226" }, "S_228": { "l": "S_229", "r": "S_227" }, "S_229": { "l": "S_230", "r": "S_228" }, "S_230": { "l": "S_231", "r": "S_229" }, "S_231": { "l": "S_232", "r": "S_230" }, "S_232": { "l": "S_233", "r": "S_231" }, "S_233": { "l": "S_134", "r": "S_232" }, "S_303L": { "l": "S_304L", "r": "S_203" }, "S_304L": { "l": "S_305L", "r": "S_303L" }, "S_305L": { "l": "S_306L", "r": "S_304L" }, "S_306L": { "l": "S_307L", "r": "S_305L" }, "S_307L": { "l": "S_308L", "r": "S_306L" }, "S_308L": { "l": "S_309L", "r": "S_307L" }, "S_309L": { "l": "S_310L", "r": "S_308L" }, "S_310L": { "l": "S_311L", "r": "S_309L" }, "S_311L": { "l": "S_312L", "r": "S_310L" }, "S_312L": { "l": "S_313L", "r": "S_311L" }, "S_313L": { "l": "S_314L", "r": "S_312L" }, "S_314L": { "l": "S_315L", "r": "S_313L" }, "S_315L": { "l": "S_316L", "r": "S_314L" }, "S_316L": { "l": "S_317R", "r": "S_315L" }, "S_317R": { "l": "S_318R", "r": "S_316L" }, "S_318R": { "l": "S_319R", "r": "S_317R" }, "S_319R": { "l": "S_320R", "r": "S_318R" }, "S_320R": { "l": "S_321R", "r": "S_319R" }, "S_321R": { "l": "S_322R", "r": "S_320R" }, "S_322R": { "l": "S_323R", "r": "S_321R" }, "S_323R": { "l": "S_324R", "r": "S_322R" }, "S_324R": { "l": "S_326R", "r": "S_323R" }, "S_326R": { "l": "S_327R", "r": "S_324R" }, "S_327R": { "l": "S_328R", "r": "S_326R" }, "S_328R": { "l": "S_329R", "r": "S_327R" }, "S_329R": { "l": "S_330R", "r": "S_328R" }, "S_330R": { "l": "S_331R", "r": "S_329R" }, "S_331R": { "l": "S_232", "r": "S_330R" }, "S_403L": { "l": "S_404L", "r": "S_303L" }, "S_404L": { "l": "S_405L", "r": "S_403L" }, "S_405L": { "l": "S_406L", "r": "S_404L" }, "S_406L": { "l": "S_407L", "r": "S_405L" }, "S_407L": { "l": "S_408L", "r": "S_406L" }, "S_408L": { "l": "S_409L", "r": "S_407L" }, "S_409L": { "l": "S_410L", "r": "S_408L" }, "S_410L": { "l": "S_411L", "r": "S_409L" }, "S_411L": { "l": "S_412L", "r": "S_410L" }, "S_412L": { "l": "S_413L", "r": "S_411L" }, "S_413L": { "l": "S_414L", "r": "S_412L" }, "S_414L": { "l": "S_415L", "r": "S_413L" }, "S_415L": { "l": "S_315L", "r": "S_414L" }, "S_419R": { "l": "S_420R", "r": "S_318R" }, "S_420R": { "l": "S_421R", "r": "S_419R" }, "S_421R": { "l": "S_422R", "r": "S_420R" }, "S_422R": { "l": "S_423R", "r": "S_421R" }, "S_423R": { "l": "S_424R", "r": "S_422R" }, "S_424R": { "l": "S_425R", "r": "S_423R" }, "S_425R": { "l": "S_426R", "r": "S_424R" }, "S_426R": { "l": "S_427R", "r": "S_425R" }, "S_427R": { "l": "S_428R", "r": "S_426R" }, "S_428R": { "l": "S_429R", "r": "S_427R" }, "S_429R": { "l": "S_430R", "r": "S_428R" }, "S_430R": { "l": "S_431R", "r": "S_429R" }, "S_431R": { "l": "S_331R", "r": "S_430R" }
//   }
// };

/*
*
* Connection Configuration
*
*/
// export const SeatgeekConfiguration: SeatgeekConnectionConfiguration = {
//   seatgeekClientUrl: null,
//   client: 'minnesota2019',
//   parkingID: '7256CE84-1674-E811-81D2-0EBF4BA87F18',
//   proxyApiUrl: environment.proxyApiUrl,
//   areaPricesMultipleSectors: true, // Not being used
//   idTranslationFromFiles: true,
//   dataConfig: {
//     baseUrl: 'assets/seatgeekdataconfig/',
//     paths: {
//       areaMapping: 'areamapping.json',
//       sectionsInAreas: 'sectionsinareas.json',
//       areaNames: 'areanames.json',
//       seats: 'seats'
//       // areaDescriptions: 'areadesc.json', // test with different file input format
//       // areaDescriptions: 'areadesc_fix.json',
//     },
//     local: true
//   }
// };
